function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })

    // 数字框初始化
    alignmentFns.initialize()
    var swiper = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
      },
    })

    new Swiper('.mySwiper2', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    var swiper2 = new Swiper('.mySwiper3', {
      spaceBetween: -6,
      slidesPerView: 3,
      watchSlidesVisibility: true, //防止不可点击
      direction: 'vertical',
      on: {
        click: function () {
          var index = this.clickedIndex
          $('#color>div')
            .eq(index)
            .addClass('active')
            .siblings()
            .removeClass('active')
        },
      },
    })
    var swiper3 = new Swiper('.mySwiper4', {
      thumbs: {
        swiper: swiper2,
      },
    })

    let prods = window.product
    function getCur(){
      let color = $('#color div.active').attr('data-val')
      let Size = $('#Size div.active').attr('data-val')
      let Settings = $('#Settings div.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == Size && item.option3 == Settings)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price / 100).toFixed(2)
      let compare = (getCur().compare_at_price / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      $('.product-infos .price-group .price1 span').html(price)
      $('.product-infos .price-group .price2 span').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".product-infos .price-group .price3 span").html(off_font);
    }
    
    $('.option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      let index1 = $('#color div.active').index()
      let index2 = $('#Size div.active').index()
      let index3 = $('#Settings div.active').index()
      // if(index1 == 1 && index2 == 0 && index3 == 1 || index1 == 5 && index2 == 0 && index3 == 1){
      //   $('.sp-btn-style').addClass('sold_out')
      //   $('.sp-btn-style div').html('Uitverkocht')
      //   $('#addCart').addClass('sold_out')
      // }else{
      //   $('.sp-btn-style').removeClass('sold_out')
      //   $('.sp-btn-style div').html('KOOP NU')
      //   $('#addCart').removeClass('sold_out')
      // }
      changePrice()
    })

    // style选项
    let typeOptions = $('#color .option')
    let img0 = $('.p-img')

    // 切换选项
    function checkType(index) {
      console.log(index,'--')
      swiper3.slideTo(index, 1000, false)
      // $('.img>img').attr('src', './image/pro-' + index + '.png')
    }
    typeOptions.click(function () {
      let index = $(this).index()
      let index2 = $('#Settings .option.active').index()
      checkType(index)
    })
    $('#Settings .option').click(function () {
      let index = $('#color .option.active').index()
      checkType(index)
    })
    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 1000)

    $('.buyNow').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    
     $('#addCart').click(function () {
        // do something here
        var data = {
          id: getCur().id,
          quantity: $('#2').val(),
        };
        
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
            });
          },
          dataType: "json",
        });
        
        var indexs = swiper3.activeIndex
        var img = $(
          '.mySwiper4 .swiper-wrapper .swiper-slide:eq(' + indexs + ')>img'
        )
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: '700px',
          height: '536px',
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: 137,
            left: offset.left + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
            window.location.href = '/cart'
          }
        )
      })
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
    $('.sp_system0').css('letter-spacing', '0px')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  var alignmentFns = {
    inputs: [],
    init: function (input, step, max, min, digit) {
      var width = 405
      var height = 105
      var _this = this
      width += 3
  
      input.attr('readonly', 'readonly')
      //设置不分样式
      input.css('border', 'none')
      input.css('width', width - height * 2 - 2)
      input.css('height', height)
      input.css('padding', '0px')
      input.css('margin', '0px')
      input.css('text-align', 'center')
      input.css('vertical-align', 'middle')
      input.css('line-height', height + 'px')
      input.css('background-color', 'transparent')
  
      //添加左右加减号
      input.wrap(
        "<div id = '" +
          input.attr('id') +
          "div' style = '  border-radius: 14px;overflow:hidden;display: flex;width:" +
          width +
          'px;height:' +
          height +
          "px;border: 4px solid #BFBFBF;'></div>"
      )
      input.before(
        "<div id = '" +
          input.attr('id') +
          "l'  onselectstart = 'return false;' style = 'font-size:56px;color:rgba(124, 124, 124, 1);-moz-user-select:none;cursor:pointer;text-align:center;width:" +
          height +
          'px;height:' +
          height +
          'px;line-height:' +
          height +
          "px;float:left;;color:#666666;'>—</div>"
      )
      input.after(
        "<div id = '" +
          input.attr('id') +
          "r'  onselectstart = 'return false;' style = '-moz-user-select:none;cursor:pointer;text-align:center;font-size:56px;color:rgba(124, 124, 124, 1);width:" +
          height +
          'px;height:' +
          height +
          'px;line-height:' +
          height +
          "px;float:right;color:#666666;'> + </div>"
      )
      //左右调用执行
      $('#' + input.attr('id') + 'l').click(function () {
        _this.execute(input, step, max, min, digit, true)
      })
      $('#' + input.attr('id') + 'r').click(function () {
        _this.execute(input, step, max, min, digit, false)
      })
    },
    execute: function (input, step, max, min, digit, _do) {
      var val = parseFloat(this.format(input.val(), digit))
      var ori = val
      if (_do) val -= step
      if (!_do) val += step
      if (val < min) {
        val = min
      } else if (val > max) {
        val = max
      }
      input.val(this.format(val, digit)).change()
    },
    format: function (val, digit) {
      if (isNaN(val)) {
        val = 0
      }
      return parseFloat(val).toFixed(digit)
    },
    // 类型
    data: {
      default_data: {
        step: 0.1,
        min: 0,
        max: 99,
        digit: 1,
      },
    },
    // 初始化
    initialize: function () {
      //使用控件必须有以下属性或者引用alignment类
      var inputs = $(
        'input[user_data], input[data-digit], input[data-step], input[data-min], input[data-max], input.alignment'
      )
  
      inputs.each(function () {
        // 记录原始input代码
        alignmentFns.inputs.push(this.outerHTML)
        //预设值数据选择
        var data = alignmentFns.data
  
        var user_data = eval('data.' + $(this).attr('user_data'))
        if (user_data == null) {
          user_data = JSON.parse(JSON.stringify(data.default_data))
        }
  
        var digit = $(this).data('digit')
        if (digit != null && !isNaN(parseFloat(digit))) {
          digit = parseFloat(digit).toFixed(0)
          user_data.digit = parseFloat(digit)
        }
  
        var step = $(this).data('step')
        if (step != null && !isNaN(parseFloat(step))) {
          user_data.step = parseFloat(step)
        }
        var min = $(this).data('min')
        if (min != null && !isNaN(parseFloat(min))) {
          user_data.min = parseFloat(min)
        }
  
        var max = $(this).data('max')
        if (max != null && !isNaN(parseFloat(max))) {
          user_data.max = parseFloat(max)
        }
        //自动装载
        alignmentFns.init(
          $(this),
          user_data.step,
          user_data.max,
          user_data.min,
          user_data.digit
        )
  
        var data_edit = $(this).data('edit')
        if (data_edit) {
          $(this).attr('readonly', null)
        }
      })
    },
    destroy: function () {
      var inputs = this.inputs
      $.each(inputs, function (index, obj) {
        var input = $(obj)[0]
        var id = input.id
        $('#' + id + 'div').replaceWith(input)
      })
    },
    // 动态添加类型
    createType: function (types) {
      $.each(types, function (index, obj) {
        alignmentFns.data[obj.type] = obj.data
      })
    },
  }
  
}

mainRender()
